import { useQuery } from '@tanstack/react-query';
import { ITimeRecording } from '../../Interfaces/ITimeRecording';
import { ITimeRecordingBreak } from '../../Interfaces/ITimeRecordingBreak';
import { customFetcher } from '../useFetch';

export const useGetTimeRecords = () => {
  const {
    data: timeRecords,
    isLoading: isLoadingTimeRecords,
    refetch: refetchTimeRecords,
  } = useQuery<ITimeRecording[]>({
    queryKey: ['timerecording'],
    queryFn: () => customFetcher({ endpoint: '/timerecording' }),
  });

  return { timeRecords, isLoadingTimeRecords, refetchTimeRecords };
};

export const useGetTimeRecordBreaks = () => {
  const { data: timeRecordBreaks, isLoading: isLoadingTimeRecordBreaks } =
    useQuery<ITimeRecordingBreak[]>({
      queryKey: ['timerecordingbreak'],
      queryFn: () => customFetcher({ endpoint: '/timerecordingbreak' }),
    });

  return { timeRecordBreaks, isLoadingTimeRecordBreaks };
};

export const useGetAllTimeRecords = () => {
  const {
    data: allTimeRecords,
    isLoading: isLoadingAllTimeRecords,
    refetch: refetchAllTimeRecords,
  } = useQuery<ITimeRecording[]>({
    queryKey: ['timerecording/getAll'],
    queryFn: () => customFetcher({ endpoint: '/timerecording/getAll' }),
  });

  return { allTimeRecords, isLoadingAllTimeRecords, refetchAllTimeRecords };
};

export const useGetOwnTimeRecords = () => {
  const {
    data: timeRecords,
    isLoading: isLoadingTimeRecords,
    refetch: refetchTimeRecords,
  } = useQuery<ITimeRecording[]>({
    queryKey: ['timerecording'],
    queryFn: () => customFetcher({ endpoint: '/timerecording' }),
  });

  return { timeRecords, isLoadingTimeRecords, refetchTimeRecords };
};
